import { UserSkillDto } from "../../dtos/userSkill/UserSkillDto";
import instance, { del, get, patch, post } from "../../utills/BaseService";

export async function createUserSkill(dispatch: any, details: UserSkillDto): Promise<string|null> {
    return await post(dispatch, '/userSkill/createUserSkill', details);
 };
export async function getUniqueSkillWithEmpCount(dispatch: any): Promise<string|{SkillName:string,employeeCount:number}[]|[]> {
    return await get(dispatch, '/userSkill/uniqueSkillsWithEmpCount',null);
 };

 export async function getAllUserSkillsRelatedToGoal(dispatch:any,input:{GoalName:string,EmployeeCode:string}):Promise<{SkillName:string}[]|[]>{
    return await get(dispatch, '/userSkill/getAllUserSkillsOfAGoal',input);
 }
 export async function getSkillByEmpCode(dispatch:any,input:{EmployeeCode:string}):Promise<{SkillName:string}[]|[]>{
    return await get(dispatch, '/userSkill/getSkillByEmpCode',input);
 }

 export async function getEmployeesBySkillName(dispatch:any,input:{skillName:string}){
   return await get(dispatch,'/userSkill/getEmployeesBySkillName',input)
 }

 export async function deleteSkillByEmpCodeAndSkillName(dispatch:any,input:{EmployeeCode:string,SkillName:string}){
   return await post(dispatch,'/userSkill/deleteSkillByEmpcodeAndSkillName',input)
}